import { gql } from '@zenbusiness/application-commons-graphql';

export const SYNC_CARD_MUTATION = gql`
  mutation syncInstantFundingCards($businessEntityUuid: UUID!) {
    syncInstantFundingCards(businessEntityUuid: $businessEntityUuid) {
      uuid
      instantFundingAccountUuid
      cardStatus
      cardReviewStatus
      cardCompany
      cardType
      cardHolderFirstName
      cardHolderLastName
      cardLastFourDigits
      cardExpirationDate
      isCardPullEnabled
      isCardPushEnabled
      isSourceCard
      isInstantFundingCardRemoved
      isCardValidForTransfers
    }
  }
`;

export const INSTANT_TRANSFER_MUTATION = gql`
  mutation createInstantFundingTransfer($input: CreateInstantFundingTransferInput!) {
    createInstantFundingTransfer(input: $input) {
      uuid
      routineName
      routineStatus
      sourceCardUuid
      amount {
        amount
        currency
        formattedAmount
      }
      createdDatetime
      updatedDatetime
    }
  }
`;

export const ACCEPT_ASTRA_TERMS_MUTATION = gql`
  mutation acceptInstantFundingTerms($businessEntityUuid: UUID!) {
    acceptInstantFundingTerms(businessEntityUuid: $businessEntityUuid) {
      uuid
    }
  }
`;

export const CREATE_BANKING_CARD_FOR_INSTANT_FUNDING = gql`
  mutation createBankingCardForInstantFunding($input: CreateBankingCardForInstantFundingInput!) {
    createBankingCardForInstantFunding(input: $input) {
      uuid
    }
  }
`;

export const CREATE_ASTRA_TOKEN_MUTATION = gql`
  mutation createInstantFundingAuthTokens($businessEntityUuid: UUID!) {
    createInstantFundingAuthTokens(businessEntityUuid: $businessEntityUuid) {
      accessToken
      accessTokenExpiryDatetime
    }
  }
`;

export const CREATE_BANKING_INSTANT_FUNDING_DEBIT_CARD = gql`
  mutation createBankingInstantFundingDebitCard($input: BankingInstantFundingDebitCardInput!) {
    createBankingInstantFundingDebitCard(input: $input) {
      uuid
      instantFundingAccountUuid
      cardStatus
      cardReviewStatus
      cardCompany
      cardType
      cardHolderFirstName
      cardHolderLastName
      cardLastFourDigits
      cardExpirationDate
      isCardPullEnabled
      isCardPushEnabled
      isSourceCard
      isInstantFundingCardRemoved
    }
  }
`;

export const CREATE_INSTANT_FUNDING_ACCOUNT = gql`
  mutation createInstantFundingAccount($businessEntityUuid: UUID!) {
    createInstantFundingAccount(businessEntityUuid: $businessEntityUuid) {
      accountStatus
    }
  }
`;
